module.exports = __webpack_public_path__ + "img/рз_1.9746a480.png";